import { openMainFormSuccessPopup } from './mainForm.js';

const setInvalidState = ( form, isInvalid ) => {
	const line = form.querySelector( '.site-footer-v2__email-line' );

	if ( line ) {
		line.classList.toggle( '!bg-[#E53935]', isInvalid );
	}
};

export function initFooterFeedbackForms() {
	document.querySelectorAll( '[data-role="footer-feedback-form"]' ).forEach( form => {
		const emailInput = form.querySelector( '[name="feedback_email"]' );

		emailInput && emailInput.addEventListener( 'input', () => {
			if ( emailInput.value.trim() && emailInput.validity.valid ) {
				setInvalidState( form, false );
			}
		} );

		form.addEventListener( 'submit', async event => {
			event.preventDefault();

			if ( !emailInput || !emailInput.value.trim() || !emailInput.validity.valid ) {
				setInvalidState( form, true );
				emailInput && emailInput.focus();
				return;
			}

			const button = form.querySelector( '[type="submit"]' );
			button && ( button.disabled = true );

			try {
				const formData = new FormData( form );
				formData.append( 'action', 'submit_feedback_form' );
				formData.append( 'nonce', window.var_from_php?.feedback_form_nonce || '' );

				const response = await fetch( window.var_from_php.ajax_url, {
					method: 'POST',
					body: formData,
				} );
				const result = await response.json();

				if ( result.success ) {
					form.reset();
					setInvalidState( form, false );
					openMainFormSuccessPopup();
					return;
				}

				if ( result.data && Array.isArray( result.data.fields ) && result.data.fields.includes( 'feedback_email' ) ) {
					setInvalidState( form, true );
				}
			} catch ( error ) {
				return;
			} finally {
				button && ( button.disabled = false );
			}
		} );
	} );
}
